import React, { useState } from "react";
import {
  Container,
  LayoutContainer,
  TabContainer,
  TabNavigationTab,
} from "./ProfileStyles";

import ProfileTab from "../../components/ProfileComponent/ProfileTab";
import PasswordTab from "../../components/ProfileComponent/PasswordTab";
import TeamTab from "../../components/ProfileComponent/TeamTab";

const Profile = () => {
  const initState = {
    profile: true,
    password: false,
    team: false,
  };

  const [tab, setTab] = useState(initState);

  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>
            {tab.profile
              ? "Profile"
              : tab.password
              ? "Password"
              : tab.team
              ? "Team Management"
              : "Profile"}
          </h3>
        </div>
      </div>
      <LayoutContainer>
        <TabContainer>
          <TabNavigationTab>
            <ul>
              <li>
                <a
                  href="#profile"
                  className={tab.profile ? "active" : ""}
                  onClick={() =>
                    setTab((tab) => ({ ...initState, profile: true }))
                  }
                >
                  Profile
                </a>
              </li>
              <li>
                <a
                  href="#password"
                  className={tab.password ? "active" : ""}
                  onClick={() =>
                    setTab((tab) => ({
                      ...initState,
                      profile: false,
                      password: true,
                      team: false,
                    }))
                  }
                >
                  Password
                </a>
              </li>
              <li>
                <a
                  href="#team"
                  className={tab.team ? "active" : ""}
                  onClick={() =>
                    setTab((tab) => ({
                      ...initState,
                      profile: false,
                      password: false,
                      team: true,
                    }))
                  }
                >
                  Team
                </a>
              </li>
            </ul>
          </TabNavigationTab>
        </TabContainer>

        <div className="tab-content">
          {tab.profile && <ProfileTab />}

          {tab.password && <PasswordTab />}

          {tab.team && <TeamTab />}
        </div>
      </LayoutContainer>
    </Container>
  );
};

export default Profile;
